export const AUDIT_LOGS_ACTION_TYPES = {
    GET_FILTER_PRESETS_SUCCESS:     "AUDIT_GET_FILTER_PRESETS_SUCCESS",
    CREATE_FILTER_PRESET_SUCCESS:   "AUDIT_CREATE_FILTER_PRESET_SUCCESS",
    REMOVE_FILTER_PRESET_SUCCESS:   "AUDIT_REMOVE_FILTER_PRESET_SUCCESS",
    SELECT_FILTER_PRESET:           "AUDIT_SELECT_FILTER_PRESET",

    UPDATE_GENERIC_FILTER:          "AUDIT_UPDATE_GENERIC_FILTER",
};